import React, { useRef } from 'react';

/**
 * SyncedTableScroll — horizontal-scroll wrapper for wide tables.
 *
 * iter563: The top mirror-scrollbar has been removed. Now that every
 * table renders a persistent Pagination Footer directly below itself,
 * we no longer need a second scrollbar above the header row. The
 * component keeps its name (used by many callers) and still exposes
 * `-body-scroll` for testing, but only renders the single scroll
 * container.
 */
export const SyncedTableScroll = ({ children, minWidth = '1400px', maxHeight, testId, className = '' }) => {
  const bodyRef = useRef(null);
  // maxHeight="100%" means "fill the flex parent and scroll vertically inside it".
  // A literal max-height:100% is ignored by browsers when the parent height is auto,
  // so we use flex sizing instead.
  const fill = maxHeight === '100%';
  return (
    <div className={`${fill ? 'flex min-h-0 flex-1 flex-col' : ''} ${className}`.trim()} data-testid={testId}>
      <div
        ref={bodyRef}
        className={`scrollbar-corner-neutral overflow-x-auto ${fill ? 'min-h-0 flex-1 overflow-y-auto' : ''}`.trim()}
        style={maxHeight && !fill ? { maxHeight } : undefined}
        data-testid={`${testId}-body-scroll`}
      >
        <div style={{ minWidth }}>{children}</div>
      </div>
    </div>
  );
};
